module.exports = __webpack_public_path__ + "img/main-logo.c34a2fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/main-logo.svg
// module id = 69
// module chunks = 1